"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var harris_icon_font_1 = __importDefault(require("@rotaryintl/harris-icon-font"));

var harris_tooltip_1 = __importDefault(require("@rotaryintl/harris-tooltip"));

var classnames_1 = __importDefault(require("classnames"));

var formik_1 = require("formik");

require("./styles.css");
/**
 * Base component for form elements, handling label, description and error
 * display.
 */


var Element = function (props) {
  var labelHidden = props.labelHidden,
      _a = props.hasLabelMargin,
      hasLabelMargin = _a === void 0 ? true : _a,
      name = props.name,
      description = props.description,
      disabled = props.disabled,
      label = props.label,
      tooltipText = props.tooltipText,
      descriptionHidden = props.descriptionHidden,
      descriptionHighlighted = props.descriptionHighlighted,
      required = props.required,
      children = props.children,
      classes = props.classes,
      _b = props.showError,
      showError = _b === void 0 ? true : _b,
      _c = props.displayLabelByDefault,
      displayLabelByDefault = _c === void 0 ? true : _c,
      validate = props.validate,
      notice = props.notice,
      showErrorMessage = props.showErrorMessage,
      characters = props.characters,
      displayCharLimit = props.displayCharLimit;

  var _d = classes || {},
      _e = _d.container,
      container = _e === void 0 ? '' : _e,
      _f = _d.content,
      content = _f === void 0 ? 'element_content' : _f,
      _g = _d.item,
      item = _g === void 0 ? '' : _g;

  var _h = (0, formik_1.useField)({
    name: name,
    validate: validate
  }),
      field = _h[0],
      meta = _h[1];

  var getCharNumber = function () {
    var _a;

    return ((_a = field.value) === null || _a === void 0 ? void 0 : _a.length) || 0;
  };

  return (0, jsx_runtime_1.jsxs)("div", __assign({
    className: (0, classnames_1.default)('rwc-form-element', container),
    "aria-describedby": "".concat(name, "-description")
  }, {
    children: [displayLabelByDefault && (0, jsx_runtime_1.jsx)("div", __assign({
      className: (0, classnames_1.default)('inner', item, {
        'inner-margin': !labelHidden && hasLabelMargin
      })
    }, {
      children: (0, jsx_runtime_1.jsxs)("label", __assign({
        htmlFor: name,
        className: (0, classnames_1.default)('label', {
          'screen_only': labelHidden,
          'label-inline-block': tooltipText,
          'label-block': !tooltipText
        })
      }, {
        children: [(0, jsx_runtime_1.jsx)("span", {
          children: label
        }), required ? (0, jsx_runtime_1.jsx)("span", __assign({
          "aria-hidden": "true",
          className: "required"
        }, {
          children: "*"
        })) : null, tooltipText && (0, jsx_runtime_1.jsx)(harris_tooltip_1.default, {
          content: tooltipText
        })]
      }))
    })), notice && (0, jsx_runtime_1.jsx)("div", __assign({
      className: "notice"
    }, {
      children: notice
    })), (0, jsx_runtime_1.jsx)("div", __assign({
      className: content
    }, {
      children: children
    })), (0, jsx_runtime_1.jsxs)("div", __assign({
      className: "description-characters"
    }, {
      children: [showError && meta.touched && meta.error || showErrorMessage ? (0, jsx_runtime_1.jsxs)("div", __assign({
        className: "error"
      }, {
        children: [(0, jsx_runtime_1.jsx)(harris_icon_font_1.default, {
          type: "fas-circle-exclamation",
          className: "errormark"
        }), meta.error]
      })) : description && (0, jsx_runtime_1.jsx)("p", __assign({
        id: "".concat(name, "-description"),
        className: (0, classnames_1.default)('description', {
          screen_only: descriptionHidden,
          description_disabled: disabled,
          description_highlighted: descriptionHighlighted
        })
      }, {
        children: description
      })), characters && displayCharLimit && (0, jsx_runtime_1.jsxs)("p", __assign({
        className: "charLimit"
      }, {
        children: [getCharNumber(), "/", characters]
      }))]
    }))]
  }));
};

exports.default = Element;